import React, { useMemo } from "react"
import Translation from "components/Translation"
import Button, { TButtonProps } from "components/Button"
import CalendarIcon from "components/Icons/Calendar.icon"
import { StyledGhostTodayButton } from "./style"

export type TTodayButtonProps = TButtonProps & {
  className?: string
  buttonVariant?: "default" | "ghost"
}

const TodayButton: React.FC<TTodayButtonProps> = ({ buttonVariant = "default", ...buttonProps }) => {
  const variantProps = useMemo<TButtonProps>(() => {
    switch (buttonVariant) {
      case "default":
        return { variant: "outlined" }
      case "ghost":
        return { variant: "text", color: "inherit", startIcon: <CalendarIcon /> }
      default:
        return {}
    }
  }, [buttonVariant])

  const ButtonComponent = buttonVariant === "default" ? Button : StyledGhostTodayButton

  return (
    <ButtonComponent {...variantProps} {...buttonProps}>
      <Translation label="component.today.button.today" />
    </ButtonComponent>
  )
}

export default TodayButton
